import { Table, TableProps, TableCell, TableCellProps } from '@mui/material';

interface SafeTableProps extends TableProps {
	children: React.ReactNode;
}

interface SafeTableCellProps extends TableCellProps {
	children: React.ReactNode;
}

export function SafeTable({ children, ...props }: SafeTableProps) {
	return (
		<Table
			{...props}
			style={{
				border: 0,
				...props.style
			}}
		>
			{children}
		</Table>
	);
}

export function SafeTableCell({ children, ...props }: SafeTableCellProps) {
	return (
		<TableCell
			{...props}
			style={{
				backgroundColor: 'transparent',
				...props.style
			}}
		>
			{children}
		</TableCell>
	);
}